/**
 * FormatoArquivoRelatorio
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {FormatoArquivoRelatorioCollection} from '@/model/collection/FormatoArquivoRelatorioCollection'

/* TODO: review generated class */
export class FormatoArquivoRelatorio extends Resource {
  idFormatoArquivoRelatorioPk: number = 0

  descricao: string | null = null

  get $id() {
    return this.idFormatoArquivoRelatorioPk
  }
  set $id(val) {
    this.idFormatoArquivoRelatorioPk = val
  }

  /**
   * Gets a instance of a given ID of FormatoArquivoRelatorio
   */
  async getFormatoArquivoRelatorio(id: number) {
    return await Request.get(`/admin/formato-arquivo-relatorio/${id}`)
      .name('getFormatoArquivoRelatorio')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of FormatoArquivoRelatorio
   */
  static async listFormatoArquivoRelatorio(params: any) {
    return await Request.get(`/admin/formato-arquivo-relatorio`, {params})
      .name('listFormatoArquivoRelatorio')
      .as(FormatoArquivoRelatorioCollection)
      .getData()
  }

  /**
   * Persists a new instance of FormatoArquivoRelatorio. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistFormatoArquivoRelatorio() {
    return await Request.post(`/admin/formato-arquivo-relatorio`, this)
      .name('persistFormatoArquivoRelatorio')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of FormatoArquivoRelatorio to use it in a CSV file
   */
  static async listCsvFormatoArquivoRelatorio(params: any) {
    return await Request.get(`/admin/formato-arquivo-relatorio/csv`, {params})
      .name('listCsvFormatoArquivoRelatorio')
      .as(FormatoArquivoRelatorioCollection)
      .getData()
  }
}
